import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import WhyLocalAI from '@/components/WhyLocalAI';
import ThreeLayers from '@/components/ThreeLayers';
import AppShowcase from '@/components/AppShowcase';
import Enterprise from '@/components/Enterprise';
import TechSpecs from '@/components/TechSpecs';
import Footer from '@/components/Footer';
import { useI18n } from '@/i18n';

export default function Home() {
  const { language } = useI18n();

  return (
    <div className="min-h-screen" lang={language === 'zh' ? 'zh' : 'en'}>
      <Navbar />
      <Hero />
      <WhyLocalAI />
      <ThreeLayers />
      <AppShowcase />
      <Enterprise />
      <TechSpecs />
      <Footer />
    </div>
  );
}
